"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var core_1 = require("@material-ui/core");
var QAHeader_1 = require("./QAHeader");
var useStyles = core_1.makeStyles(function () { return ({
    avatar: {
        width: 30,
        height: 30
    }
}); });
exports.Question = function (_a) {
    var q = _a.q, info = _a.info;
    var classes = useStyles();
    return (react_1.default.createElement(QAHeader_1.QAHeader, { title: q, titleClass: "faq-answer-title", avatar: react_1.default.createElement(core_1.Avatar, { "aria-label": "Question", className: clsx_1.default('faq-answer-q', classes.avatar) }, info ? '!' : 'Q') }));
};
//# sourceMappingURL=Question.js.map